import React, { useState, forwardRef, useRef } from "react";
import "./PhotoSection.css";

const PhotoSection = forwardRef(({ 
  onPhotoChange, 
  scrollToNextSection, 
  title = "",
  description = "",
  showChristmasDecoration = false,
  leftTreeSrc,
  rightTreeSrc
}, ref) => {
  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleFile(file);
    }
  };

  const handleFile = (file) => {
    // Перевірка типу файлу
    if (!file.type.startsWith('image/')) {
      alert('Будь ласка, оберіть файл зображення (JPG, PNG, GIF)');
      return;
    }

    // Перевірка розміру файлу (максимум 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('Розмір файлу не повинен перевищувати 10MB');
      return;
    }

    setUploadedImage(file);
    
    // Створення preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);

    // Виклик callback функції
    if (onPhotoChange) {
      onPhotoChange("photo", file);
    }

    // Автоматичний скрол до наступної секції
    if (scrollToNextSection) {
      setTimeout(() => scrollToNextSection(), 500);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      handleFile(file);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };



  return (
    <section ref={ref} className={`photo-section-PhotoSection ${showChristmasDecoration ? 'christmas-themed-PhotoSection' : ''}`}>
   
      <h2 className="title-PhotoSection">{title}</h2>
      {/* <p className="description">
        {description}
      </p> */}

      <div className="photo-upload-container-PhotoSection">
        {showChristmasDecoration && (
          <div className="snowflakes-PhotoSection">
            {Array.from({ length: 15 }, (_, index) => (
              <div 
                key={index} 
                className="snowflake-PhotoSection" 
                style={{
                  animationDelay: `${Math.random() * 3}s`,
                  left: `${Math.random() * 100}%`,
                  animationDuration: `${3 + Math.random() * 3}s`
                }}
              >
                ❄️
              </div>
            ))}
          </div>
        )}
        
        <div 
          className={`photo-upload-area-PhotoSection ${imagePreview ? 'has-image-PhotoSection' : ''}`}
          onClick={handleClick}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >    {showChristmasDecoration && leftTreeSrc && (
        <img src={leftTreeSrc} alt="Left Christmas tree" className="left-tree-decoration-PhotoSection" />
      )}
      {showChristmasDecoration && rightTreeSrc && (
        <img src={rightTreeSrc} alt="Right Christmas tree" className="right-tree-decoration-PhotoSection" />
      )}
          {imagePreview ? (
            <>
              <img 
                src={imagePreview} 
                alt="Uploaded photo" 
                className="uploaded-image-PhotoSection"
              />
              <div className="image-overlay-PhotoSection">
                <div className="overlay-text-PhotoSection">
                  Click to change photo
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="upload-icon-PhotoSection">📷</div>
              {/* <div className="upload-text">
                <h3>Завантажити фото</h3>
                <p>Натисніть або перетягніть файл сюди</p>
              </div> */}
            </>
          )}
          
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            className="hidden-input-PhotoSection"
          />
        </div>

       

        <button 
          type="button"
          onClick={handleClick}
          className={`upload-photo-PhotoSection ${
    uploadedImage ? "has-image" : "no-image"
  }`}
        >
          {!uploadedImage ? "Upload photo" : "Change photo"}
        </button>

        {/* <div className="photo-tips">
          <h4>💡 Поради для кращого результату:</h4>
          <ul>
            <li>На зображенні має бути одна людина або тварина</li>
            <li>Якісне фото з обличчям ближче до центру композиції</li>
            <li>Чітка композиція без обрізаних важливих елементів</li>
          </ul>
        </div> */}
      </div>
    </section>
  );
});

export default PhotoSection;
